import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import entryActions from '../entry-actions';
import PointSystemModal from '../components/PointSystemModal';
import selectors from '../selectors';

const selectContentViewPlansByPointSystemId = selectors.makeSelectContentViewPlansByPointSystemId();

const mapStateToProps = (state) => {
  const pointSystem = selectors.selectPointSystemForSettingsModal(state);
  const modalData = selectors.selectCurrentModalData(state);

  const currentUser = selectors.selectCurrentUser(state);
  const config = selectors.selectConfig(state);
  const superuserIds = Array.isArray(config?.superuserIds) ? config.superuserIds : [];
  const canEditPointSystemSettings =
    currentUser?.isSAdmin === true ||
    (currentUser?.id && superuserIds.map(String).includes(String(currentUser.id)));

  const contentTypes = selectors.selectContentTypesForPointSystem(state, pointSystem?.id);
  const contentTypeTemplates = selectors.selectContentTypeTemplates(state);
  const boardPointSystem = selectors.selectBoardLevelPointSystemForCurrentBoard(state);
  const currentBoard = selectors.selectCurrentBoard(state);

  return {
    open: true,
    pointSystem,
    canEditPointSystemSettings,
    contentTypes,
    contentTypeTemplates,
    contentViewPlans: selectContentViewPlansByPointSystemId(state, pointSystem?.id),
    selectedTemplateId: modalData?.selectedTemplateId || pointSystem?.id || null,
    boardSourceTemplateId: boardPointSystem?.sourcePointSystemId
      ? String(boardPointSystem.sourcePointSystemId)
      : null,
    currentBoardName: currentBoard?.name || '',
    employeePlans: selectors.selectEmployeePlansByPointSystemId(state, pointSystem?.id),
    dampingCoefficients: selectors.selectDampingCoefficientsForPointSystem(
      state,
      pointSystem?.id,
    ),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onClose: entryActions.closeModal,
      onSelectTemplate: entryActions.openPointSystemTemplatesModal,
      onEmployeePlansFetch: entryActions.fetchEmployeePlansInCurrentBoard,
      onEmployeePlanCreate: entryActions.createEmployeePlanInCurrentBoard,
      onEmployeePlanUpdate: entryActions.updateEmployeePlan,
      onEmployeePlanDelete: entryActions.deleteEmployeePlan,
      onContentViewPlansFetch: entryActions.fetchContentViewPlansInCurrentBoard,
      onContentViewPlanGetOrCreate: entryActions.getOrCreateContentViewPlanInCurrentBoard,
      onContentViewPlanUpdate: entryActions.updateContentViewPlan,
      onContentCardDefaultsFetch: entryActions.fetchContentCardDefaultsInCurrentBoard,
      onContentCardDefaultCreate: entryActions.createContentCardDefaultInCurrentBoard,
      onContentCardDefaultUpdate: entryActions.updateContentCardDefault,
      onContentCardDefaultDelete: entryActions.deleteContentCardDefault,
      onDampingCoefficientsFetch: entryActions.fetchDampingCoefficientsInCurrentBoard,
      onDampingCoefficientCreate: entryActions.createDampingCoefficient,
      onDampingCoefficientUpdate: entryActions.updateDampingCoefficient,
      onDampingCoefficientDelete: entryActions.deleteDampingCoefficient,
      onContentTypesFetch: entryActions.fetchContentTypesInCurrentBoard,
      onContentTypeCreate: entryActions.createContentTypeInCurrentBoard,
      onContentTypeUpdate: entryActions.updateContentType,
      onContentTypeDelete: entryActions.deleteContentType,
      onContentTypeTemplatesFetch: entryActions.fetchContentTypeTemplates,
      onContentTypeTemplateCreate: entryActions.createContentTypeTemplate,
      onContentTypeTemplateUpdate: entryActions.updateContentTypeTemplate,
      onContentTypeTemplateDelete: entryActions.deleteContentTypeTemplate,
      onContentTypeTemplateItemCreate: entryActions.createContentTypeTemplateItem,
      onContentTypeTemplateItemUpdate: entryActions.updateContentTypeTemplateItem,
      onContentTypeTemplateItemDelete: entryActions.deleteContentTypeTemplateItem,
      onContentTypeTemplateApply: entryActions.applyContentTypeTemplateInCurrentBoard,
      onPointSystemUpdate: entryActions.updateBoardPointSystemSettings,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(PointSystemModal);
